import $ from 'jquery';
import apiFetch from "@wordpress/api-fetch";

const $commentsEl = $('.post-card__comments-wrapper');

$(function () {
    if ($commentsEl.length > 0) {
        $commentsEl.each(function () {
            commentInit($(this));
        });
    }
});

const commentInit = (el) => {
    const data = {
        postId: el.data('post'),
        content: '',
    };

    bindCommentInput(el, data);
};

const reRenderComments = async (element, data, scrollTop = false) => {
    const result = await createComment(data);
    $(`[data-post='${data.postId}']`).html(result.html);

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindCommentInput = (element, data) => {
    element.on('submit', '.post-card__form', function (e) {
        e.preventDefault();
        const $thisEl = $(this);
        data.content = $thisEl.find('.post-card__input').val();
        
        reRenderComments(element, data);
    });

};

const createComment = async (data) => {
    try {
        const response = await apiFetch({
            path: "/xixoio/v1/comment/create/" + data.postId,
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            data: data,
        });
       
        return response;
    } catch (e) {
        console.log(e);
        return null;
    }
};